"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Link');

function Link(_ref) {
  var _classnames;

  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      onClick = _ref.onClick,
      isDisabled = _ref.isDisabled,
      href = _ref.href,
      size = _ref.size,
      target = _ref.target,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "onClick", "isDisabled", "href", "size", "target"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); //Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Link.overrides); // Classes

  var rootClassName = (0, _classnames2.default)(classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.isDisabled, isDisabled), (0, _defineProperty2.default)(_classnames, classes[size], size), _classnames), classNameProp);
  var rootProps = (0, _extends2.default)({}, props, {
    className: rootClassName,
    onClick: isDisabled ? null : onClick
  });

  if (href) {
    return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
      href: href,
      target: target
    }, rootProps, override.root), children);
  } else {
    return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({}, rootProps, {
      type: "button"
    }, override.root), children);
  }
}

Link.overrides = ['root'];
Link.defaultProps = {
  overrides: {},
  size: 'medium'
};
process.env.NODE_ENV !== "production" ? Link.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onClick: _propTypes.default.func,
  children: _propTypes.default.node.isRequired,
  size: _propTypes.default.oneOf(['small', 'medium', 'big']),
  isDisabled: _propTypes.default.bool,

  /** Render the component as a tag <a/> with href */
  href: _propTypes.default.string,

  /** native <a/> target */
  target: _propTypes.default.string
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Link);

exports.default = _default;